import { render, staticRenderFns } from "./StandardView.vue?vue&type=template&id=8d2d9a24&"
import script from "./StandardView.vue?vue&type=script&lang=js&"
export * from "./StandardView.vue?vue&type=script&lang=js&"
import style0 from "./StandardView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports